module.exports = new Promise((resolve, reject) => {
        var url = window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__['AUTH_APP_REMOTE_ENTRYPOINT'];
        if (!url || url === 'none.js') {
            resolve({ get: function() { return Promise.resolve(function() { return null; }); }, init: function() {} });
            return;
        }
        var script = document.createElement('script');
        script.src = url;
        script.onload = function() { resolve(window['authapp']); };
        script.onerror = reject;
        document.head.appendChild(script);
    });